const join = (...params: string[]) => params.join('/').replace(/([^:]\/)\/+/g, '$1');

export default {
    join,
};
